import * as Promise from 'bluebird'
import APIBase from './base'
import axios from 'axios'
import cu from '../lib/chunkUtil'

export default class APILocal extends APIBase {
  constructor(config) {
    super(config)

    // default for localstorage
    this.path = '/apee/v4/'
    this.postfix = '.json'
  }

  getChunk(params) {
    let me = this
    let args = arguments
    return axios
      .get(me.makeURL(me.endpoints.CHUNK(params.chunk)))
      .then(function(res) {
        return me.postprocessor(cu.normalizeChunk(res.data), args)
      })
  }

  addChunk(params) {
    return Promise.resolve(params.chunk)
  }

  updateChunk(params) {
    let page = params.page
    let db = this.db
    return db.pages.update(page.id, {
      page: page
    })
  }

  getComments(chunk) {
    let me = this
    let args = arguments
    return axios
      .get(me.makeURL(me.endpoints.COMMENTS(chunk)))
      .then(function(res) {
        return me.postprocessor(res.data, args)
      })
  }

  getChanges(chunk) {
    let me = this
    let args = arguments
    return axios
      .get(me.makeURL(me.endpoints.CHANGES(chunk)))
      .then(function(res) {
        return me.postprocessor(res.data, args)
      })
  }
}
